import React, { useEffect, useState } from "react";
import CommonTable from "../../components/commonComponents/Table/CommonTable";
import Heading from "../../components/commonComponents/Heading/Heading";
import styles from "../Inventory/Inventory.module.css";
import { RiFileExcel2Fill } from "react-icons/ri";
import { FaFileCsv, FaFilePdf } from "react-icons/fa";
import { Grid, Box, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { Edit, Delete } from "@mui/icons-material";
import Filter from "../../components/commonComponents/Filter/Filter";
import { generateCSV, generateExcel, generatePDF, handleCsvGeneration } from "../../utils/exportUtils";
import { fetchAllCustomerData } from "./Utility";
const tableCss = {
  moduleHeight: "37.9rem",
  cellPadding: "12px 16px",
  tableWidth: "100%!important",
};
const buttonArray = [
  {
    name: null,
    key: "excel",
    icon: <RiFileExcel2Fill />,
  },
  {
    name: null,
    key: "csv",
    icon: <FaFileCsv />,
  },
  {
    name: null,
    key: "pdf",
    icon: <FaFilePdf />,
  },

];

const OrderHistory = () => {

  function getActionIcons(rowData, index) {
    return (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton 
          size="small" 
          onClick={() => handleActionClick('edit', rowData, index)}
          title="Edit Customer"
        >
          <Edit fontSize="small" sx={{ color: "blue" }} />
        </IconButton>
        <IconButton 
  size="small" 
  onClick={() => handleActionClick('delete', rowData, index)}
  title="Delete Customer"
>
  <Delete fontSize="small" sx={{ color: "error.main" }} />
</IconButton>

      </Box>
    );
  }
  const [columns, setColumns] = useState([
    {
      name: "Select All",
      key: "selectAll",
      showExcel: false,
      showTable: false,
      showPDF: false,
    },
    {
      name: "Sr. No",
      key: "serial",
      showExcel: true,
      showTable: false,
      showPDF: true,
      selected: false
    },

    {
      name: "Account Name",
      key: "accountName",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
      
    },
    {
      name: "Account Type",
      key: "accountType",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
    },
    {
      name: "Order Number",
      key: "orderNumber",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
    },
    {
      name: "Order Date",
      key: "orderDate",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
    },
    {
      name: "Order Status",
      key: "orderStatus",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
    },
     {
      name: "Order Discription",
      key: "orderDescription",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
    },
    {
      name: "Sim Type",
      key: "simType",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
    },
    {
      name: "No. of Sims",
      key: "numberOfSims",
      showExcel: true,
      showTable: true,
      showPDF: true,
      selected: true
    },
    {
      name: "Action",
      key: "action",
      selected: true,
      showExcel: true,
      showTable: false,
      showPDF: true,
    },

  ]);
  const [customerList, setCustomerList] = useState([]);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [csvData, setCsvData] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
      const [createDialogOpen, setCreateDialogOpen] = useState(false)
  const [filters, setFilters] = useState({
    pageNo: 0,
    pageSize: 10,
    search: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const handlePageChange = (_, newPage) => {
    setFilters({ ...filters, pageNo: newPage });
  };

  const handleRowsPerPageChange = (event) => {
    setFilters((prev) => ({
      ...prev,
      pageNo: 0,
      pageSize: parseInt(event.target.value, 10),
    }));
  };


  const handleActionClick = (action, rowData, index) => {
    console.log('Action:', action, 'Row Data:', rowData, 'Index:', index);
    
    switch (action) {
      case 'view':
        // Handle view action
        console.log('Viewing customer:', rowData.customer_id);
        break;
      case 'edit':
        // Handle edit action
        console.log('Editing customer:', rowData.customer_id);
        break;
      case 'delete':
        // Handle delete action
        console.log('Deleting customer:', rowData.customer_id);
        break;
      default:
        console.log('Unknown action:', action);
    }
  }



  const handleButtonAction = (action) => {
    switch (action) {
      case "add_customer":
        setCreateDialogOpen(true);
        break;
      case "filter_preference":
        setShowFilterPanel(true);
        break;
      case "excel":
        generateExcel(customerList, columns, "customer_data.xlsx");
        break;
      case "pdf":
        generatePDF(customerList, columns, "customer_data.pdf");
        break;
      case "csv":
        const csvExportData = handleCsvGeneration(customerList, columns);
        setCsvData(csvExportData);
        break;
      default:
        console.log("Unknown action:", action);
    }
  };


//
  const [allCustomerData, setAllCustomerData] = useState([]);
  const fetchCustomerData = async () => {
    const data = await fetchAllCustomerData();
  
    // Ensure body is an array
    const bodyData = Array.isArray(data?.body) ? data.body : [];
    const dataWithSerialAndActions = bodyData.map((item, index) => ({
      ...item,
      orderDate: item.orderDate ? item.orderDate.split("T")[0] : "", // keep only date part
      serial: index + 1,
    }));
  
    setAllCustomerData(
      dataWithSerialAndActions.map((item, index) => ({
        ...item,
        action: getActionIcons(item, index),
      }))
    );
  };
  
  useEffect(() => {
  fetchCustomerData();
 
  }, []);

  useEffect(() => {
    const searchTerm = filters.search?.toLowerCase() || "";
    
    if (!searchTerm) {
      setCustomerList(allCustomerData);
      setTotalRows(allCustomerData.length);
      return;
    }

    const filteredData = allCustomerData.filter(item => 
      item.userName?.toLowerCase().includes(searchTerm) ||
      item.account?.toLowerCase().includes(searchTerm) ||
      item.firstName?.toLowerCase().includes(searchTerm) ||
      item.lastName?.toLowerCase().includes(searchTerm) ||
      item.email?.toLowerCase().includes(searchTerm) ||
      item.primaryPhone?.toLowerCase().includes(searchTerm) ||
      item.status?.toLowerCase().includes(searchTerm)
    );

    setCustomerList(filteredData);
    setTotalRows(filteredData.length);
  }, [filters.search, allCustomerData]);
  return (
    <>
      <div className={styles.headingContainer} style={{marginTop:"20px"}}>
        <Heading
          // heading={"Customer Management"}
          data={customerList}
          showSearch={true}
          arrowRedirection={false}
          showToFromDate={false}
          buttonArray={buttonArray}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          handleButtonAction={handleButtonAction}
          setFilters={setFilters}
          filters={filters}
        />

        <Grid
          container
          alignItems="center"
          spacing={2}
          sx={{ paddingRight: "63px", paddingBottom: "11px" }}
        >
          <Grid
            item
            md={0.4}
            sx={{ display: "flex", alignItems: "center" }}
          ></Grid>
          <Grid
            item
            md={2.6}
            sx={{ display: "flex", alignItems: "center" }}
          ></Grid>
          <Grid
            item
            md={9}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "baseline",
            }}
          >
          </Grid>
        </Grid>
      </div>
      {/* FilterPanel will be displayed on top of other content */}
      {/* <Filter
        open={showFilterPanel}
        onClose={() => setShowFilterPanel(false)}
        headers={columns}
        setHeaders={setColumns}
      /> */}
      {/* show start range , search,end range */}

      <div className={styles.container}>
      <CommonTable
  showsort={true}
  columns={columns}
  data={customerList.slice(
    filters.pageNo * filters.pageSize,
    (filters.pageNo + 1) * filters.pageSize
  )}
  setData={setCustomerList}
  tableCss={tableCss}
  filters={filters}
  totalRows={totalRows}
  onPageChange={handlePageChange}
  onRowsPerPageChange={handleRowsPerPageChange}
/>

      </div>

      {csvData && generateCSV(csvData, "customer_data.csv")}
    </>
  );
};

export default OrderHistory;
